<template>
    <loading-skeleton :loadingHeight="'200px'" class="loading-charts" v-if="!chartActive"/>

    <div v-if="chartActive" class="deliver-count-container">
        <div class="deliver-count-inner">
            <h3>{{deliveredCount}} deliveries</h3>
            <div class="total-delivered">
                <p>
                    Total delivered 
                </p>
                <p v-if="deliveredPercentChange >= 0" class="percentage-container">
                    <svg id="Layer_1" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-name="Layer 1"><path d="m12 0a12 12 0 1 0 12 12 12.013 12.013 0 0 0 -12-12zm0 22a10 10 0 1 1 10-10 10.011 10.011 0 0 1 -10 10zm5-10a1 1 0 0 1 -1 1h-3v3a1 1 0 0 1 -2 0v-3h-3a1 1 0 0 1 0-2h3v-3a1 1 0 0 1 2 0v3h3a1 1 0 0 1 1 1z"/></svg>
                    {{deliveredPercentChange}}%
                </p>
                <p v-if="deliveredPercentChange < 0" class="percentage-container negative">
                    <svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" data-name="Layer 1" viewBox="0 0 24 24"><path d="m12,0C5.383,0,0,5.383,0,12s5.383,12,12,12,12-5.383,12-12S18.617,0,12,0Zm0,22c-5.514,0-10-4.486-10-10S6.486,2,12,2s10,4.486,10,10-4.486,10-10,10Zm5-10c0,.552-.448,1-1,1h-8c-.552,0-1-.448-1-1s.448-1,1-1h8c.552,0,1,.448,1,1Z"/></svg>
                    {{deliveredPercentChange}}%
                </p>
            </div>
           
        </div>
    </div>
    <div v-show="chartActive" class="line-container">
        <canvas ref="myChart" class="line-chart" id="line"></canvas>
    </div>
    <AlertUser v-if="toggleAlertBox" @closeAlertBox="closeAlertBox($event)" :message="alertMessage"/> 
</template>

<script>
import Chart from 'chart.js/auto'
import {API} from 'aws-amplify';
import LoadingSkeleton from '../../ShipmentDashboard/LoadingSkeleton.vue'
import AlertUser from '../../../components/Popups/AlertUser.vue';

export default {
    components:{
        AlertUser,
        LoadingSkeleton
    },
    props:['refreshAfterVoidBool', 'userData', 'accountNo', 'adminDashboard'],
    data(){
        return{
            sliderValue: 1,
            sliderValueArray:[
                {value: 1, label: "Week"},
                {value: 2, label: "Month"},
                {value: 3, label: "Two Months"}
            ],
            fromDate: "",
            toDate: "",
            deliveredCount: 0,
            dayBeforeDeliverCount: 0, 
            twoDaysBeforeDeliverCount: 0,
            deliveredPercentChange: 0,
            inTransitCount: null,
            currentCount: null,
            currentShipmentCount: 10,
            changeDataArrayInput: [],
            changeDataLabelInput: null,
            lineChart: null,
            chartOptions: {
                responsive: true,
                fullSize: true,
                scales: {
                    y: {
                        ticks: {
                            color: "#b6baca",
                        },
                        grid: {
                            drawTicks: false,
                        },
                        border: {
                            dash: [5, 10],
                        },
                        },
                        x: {
                        ticks: {
                            color: "#b6baca",
                        },
                        grid: {
                            display: false,
                        },
                        border: {
                            display: false,
                        },
                    },
                },
            },
            chartData : {
                labels: [
                    'Ereyesterday',
                    'Yesterday',
                    'Today'
                ],
                datasets: [{
                    label: 'Delivered',
                    data: [10, 15, 30],
                    backgroundColor: [
                    '#33f18a'
                    ],
                    hoverOffset: 4,
                    tension: 0.3,
                    pointRadius: 1.75,
                    borderColor: "#33f18a"
                }]
            },
            toggleAlertBox: false,
            alertMessage: "",
            CurrentKey: null,
            beforeTodaysDate: null,
            todaysDate: null,
            oneDayBeforeDate: null,
            twoDaysBeforeDate: null,
            sevenDaysDate: null,
            thirtyDaysDate: null,
            sixtyDaysDate: null,
            chartActive: false,
            currentMonthName: '',
            oneDayBeforeDayName: '',
            twoDaysBeforeDayName: '',
            currentMonth: '',
            oneDayBeforeDay: null,
            twoDaysBeforeDay: null,
            oneDayBeforeMonth: '',
            twoDaysBeforeMonth: '',
            previousMonth: '',
            previousMonthName: '',
            items: `items{
                    shipmentID
                    }`
        }
    },
    watch:{
        'userData':function(newValue, oldValue) {
            if(this.userData && (!this.adminDashboard)){ 
                if((newValue !== oldValue) && oldValue.userName){
                    this.lineChart.destroy();
                }  
                this.CurrentKey = this.userData.accountNo;
                this.chartActive = false;
                if(this.lineChart){
                    this.lineChart.destroy();
                }
                this.createMyChartLine();
            } 

            if(this.userData && (this.adminDashboard)){ 
                this.CurrentKey = this.userData.accountNo;
                this.chartActive = false;
                if(this.lineChart){
                    this.lineChart.destroy();
                }
                this.createMyChartLine();
            } 
        },
        chartDataComputed(newDataSet){
            this.lineChart.destroy();
            this.chartData.datasets.data = newDataSet;
            this.createMyChartLine();
        },
        'deliveredCount':function(){
            this.deliveredPercentChange = ((this.deliveredCount - this.dayBeforeDeliverCount) / this.dayBeforeDeliverCount) * 100
            this.deliveredPercentChange = parseFloat(this.deliveredPercentChange.toFixed(2));
        }
    },
    computed:{
        chartDataComputed(){
            return this.chartData.datasets[0].data, this.chartData.labels;
        }
    },
    methods:{
        async createMyChartLine(){
            this.CurrentKey = this.userData.accountNo
            await this.getDeliveredShipmentsGraphQL(this.CurrentKey);
            this.chartData.datasets[0].data = [this.twoDaysBeforeDeliverCount, this.dayBeforeDeliverCount, this.deliveredCount]
            this.lineChart = new Chart(
                this.$refs.myChart,
                {
                    type: 'line',
                    title:{
                    text: "Deliveries"
                    },
                    data: this.chartData,
                    options: this.chartOptions
                }
            );
            this.chartActive = true;
        },
        SetSliderValue(value){
            this.sliderValue = value;
        },
        closeAlertBox(toggleAlertBox){
            this.toggleAlertBox = toggleAlertBox;
        },
        async getDeliveredShipmentsGraphQL() {
            const days = [
                { day: this.currentDay, countVar: "deliveredCount", monthVar: this.currentMonth },
                { day: this.oneDayBeforeDay, countVar: "dayBeforeDeliverCount", monthVar: this.oneDayBeforeMonth },
                { day: this.twoDaysBeforeDay, countVar: "twoDaysBeforeDeliverCount", monthVar: this.twoDaysBeforeMonth },
            ];

            try {
                this.loading = true;

                for (let { day, countVar, monthVar } of days) {
                    let nextToken = null;
                    let HistoryKey = this.CurrentKey + '-' + monthVar;
                    let deliveredCount = 0;
                    const isAdmin = this.adminDashboard;
                    const queryName = isAdmin ? "shipmentByHistoryKeyDeliveryDay" : "shipmentByHistoryKey";

                    do {
                        try {
                            const query = isAdmin
                                ? `query shipmentByHistoryKeyDeliveryDay {
                                        shipmentByHistoryKeyDeliveryDay(
                                            historyKey: "${HistoryKey}",
                                            deliveryDay: { eq: "${day}" },
                                            limit: 1000,
                                            ${nextToken ? `nextToken: "${nextToken}"` : ""}
                                        ) {
                                            ${this.items}
                                            nextToken
                                        }
                                    }`
                                : `query shipmentByHistoryKey {
                                        shipmentByHistoryKey(
                                            historyKey: "${HistoryKey}",
                                            usernameDeliveryDay: { eq: { deliveryDay: "${day}", username: "${this.userData.userName}" } },
                                            limit: 1000,
                                            ${nextToken ? `nextToken: "${nextToken}"` : ""}
                                        ) {
                                            ${this.items}
                                            nextToken
                                        }
                                    }`;

                            const response = await API.graphql({
                                query: query,
                                authMode: "AMAZON_COGNITO_USER_POOLS",
                            });

                            const shipmentData = response.data[queryName];

                            if (shipmentData.items) {
                                deliveredCount += shipmentData.items.length;
                            }

                            nextToken = shipmentData.nextToken || null; // Ensure it exits the loop when nextToken is null
                        } catch (error) {
                            console.error(error);
                            this.toggleAlertBox = true;
                            this.alertMessage = "Error getting delivered shipments";
                            break;
                        }
                    } while (nextToken);

                    this[countVar] = deliveredCount;
                }
            } finally {
                this.loading = false;
            }

            this.deliveredPercentChange = ((this.deliveredCount - this.dayBeforeDeliverCount) / this.dayBeforeDeliverCount) * 100;
            this.deliveredPercentChange = parseFloat(this.deliveredPercentChange.toFixed(2));
        }
    },
    mounted(){
        this.todaysDate = new Date(new Date().setDate(new Date().getDate())).toJSON().slice(0, 10);
        this.oneDayBeforeDate = new Date(new Date(this.todaysDate).setDate(new Date(this.todaysDate).getDate() - 1)).toJSON().slice(0, 10);
        this.twoDaysBeforeDate = new Date(new Date(this.todaysDate).setDate(new Date(this.todaysDate).getDate() - 2)).toJSON().slice(0, 10);
        this.currentMonth = this.todaysDate.slice(0,7);
        this.oneDayBeforeMonth = this.oneDayBeforeDate.slice(0,7);
        this.twoDaysBeforeMonth = this.twoDaysBeforeDate.slice(0,7);
        this.currentDay = this.todaysDate.slice(8, 10);
        this.oneDayBeforeDay = this.oneDayBeforeDate.slice(8, 10);
        this.twoDaysBeforeDay = this.twoDaysBeforeDate.slice(8, 10);
        const dayBeforeDate = new Date(`${this.oneDayBeforeDate}T00:00:00`);
        this.oneDayBeforeDayName = dayBeforeDate.toLocaleDateString('en-US', { weekday: 'long' });
        const twoDaysBeforeDate = new Date(`${this.twoDaysBeforeDate}T00:00:00`);
        this.twoDaysBeforeDayName = twoDaysBeforeDate.toLocaleDateString('en-US', { weekday: 'long' });
        this.chartData.labels[0] = this.twoDaysBeforeDayName
        this.chartData.labels[1] = this.oneDayBeforeDayName

        let previousMonthDate = new Date();
        // Set the current date to the first day of the current month
        previousMonthDate.setDate(1);
        // Subtract one day to get to the last day of the previous month
        previousMonthDate.setDate(0);
        this.previousMonth = previousMonthDate.toJSON().slice(0,7);
        if(this.lineChart){
            this.lineChart.destroy()
        }
    }
}
</script>

<style scoped>
.percentage-container svg {
	width: 12.5px;
	margin-right: 2.5px;
	fill: #00da62
}

.negative svg {
	fill: #fe804d
}

.deliver-count-container {
	display: flex;
	flex-direction: column;
	width: 100%;
	justify-content: flex-start
}

.deliver-count-inner {
	text-align: left
}

.deliver-count-inner h3 {
	margin: 0
}

.deliver-count-inner p {
	margin: 0;
	font-size: 12.5px
}

.total-delivered {
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 5%
}

.percentage-container {
	color: #00da62;
	background-color: #efefef;
	padding: 2px;
	border-radius: 99px
}

.negative {
	color: #fe804d
}

.deliver-count-inner p {
	display: flex;
	justify-content: center;
	align-items: center
}

.data-container {
	background-color: #fff;
	padding: 15px;
	border-radius: 25px;
	width: 25%;
	margin: 10px;
	box-shadow: rgba(0, 0, 0, .35) 0 5px 15px;
	display: flex;
	justify-content: center;
	align-items: center;
	height: fit-content
}

.line-container {
	height: 100%;
	width: 100%;
	display: flex;
	justify-content: center;
	align-items: center
}

.line-chart {
	width: 100%;
	cursor: pointer
}

@keyframes animate-selected-range {
	from {
		margin-left: -50%
	}

	to {
		margin-left: 0
	}
}

.loading-charts {
	margin-top: 25%
}
</style>